import { render, staticRenderFns } from "./KpFileInput.vue?vue&type=template&id=2cb1b314&scoped=true"
import script from "./KpFileInput.vue?vue&type=script&lang=js"
export * from "./KpFileInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb1b314",
  null
  
)

export default component.exports